import React, { useCallback, useEffect, useState } from "react";
import { Table, Button, Modal, Form, Card, Spinner, FormGroup } from "react-bootstrap";
import useReactRouter from "use-react-router";
import axios from "axios";
import * as _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrashAlt,
  // faBoxOpen,
  // faPlusCircle,
  // faExclamationCircle,
  faSave,
  faTimes,
  faPlus,
  // faCheck,
} from "@fortawesome/free-solid-svg-icons";
import NumberFormat from "react-number-format";
import { COLOR_APP, COLOR_GRAY, COLOR_TEXT, COLOR_WHITE } from "../../constants";
import { useToasts } from "react-toast-notifications";
import { convertCurrentDate, imageRender, moneyCurrency, splitDateTime } from "../../helpers";
// import shoppingAnimation from "../../image/sopping.json";
import moment from "moment";
import { useMutation, useLazyQuery } from "@apollo/client";
// import Lottie from "lottie-react";
import EmptyComponent from "../../components/EmptyComponent";
// import AnimationLoading from "../../components/AnimationLoading";
import { GET_STOCKS_V2 } from "../../graphql/stock/query";
import {
  DELETED_STOCK,
  UPDATE_STOCK,
  UPDATE_STOCK_V2,
  UPDATE_MANY_STOCK,
  UPDATE_STOCK_FOR_LIVE_ON_AIR,
} from "../../graphql/stock/mutation";
import { GET_OPTION_VALUES } from "../../graphql/optionValue/query";
import { GET_PRESIGN_URL } from "../../graphql/presignUrl/query";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import "./util/products.css";

import PaginationHelper from "../../helpers/PaginationHelper";
import ModalConfirmComponent from "../../components/ModalConfirmComponent";
import LoadingSpinner from "../../components/LoadingSpinner";
import { MdDateRange } from "react-icons/md";
import CurrentDateModal from "../../components/currentComponent/CurrentDateModal";

function Products() {
  const { width } = useWindowDimensions();
  const isMobile = typeof width === 'number' && width < 520;
  const { addToast } = useToasts();
  const { history } = useReactRouter();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState();
  const [searchText, setSearchText] = useState("");
  const [debounceSearchText, setDebounceSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [stockDatas, setStockDatas] = useState([]);
  const [stockTotal, setStockTotal] = useState(0);
  const [getStocksDatas, { data: loadStocksDatas, loading: loadingStock }] =
    useLazyQuery(GET_STOCKS_V2, { fetchPolicy: "cache-and-network" });
  const [getOptionValues, { data: optionValueDatas }] = useLazyQuery(
    GET_OPTION_VALUES,
    { fetchPolicy: "cache-and-network" }
  );
  const [updateStockForLiveOnAir] = useMutation(UPDATE_STOCK_FOR_LIVE_ON_AIR);
  // const [updateStock] = useMutation(UPDATE_STOCK);
  const [updateStockV2] = useMutation(UPDATE_STOCK_V2);
  const [deleteStock] = useMutation(DELETED_STOCK);
  const [updateManyStock] = useMutation(UPDATE_MANY_STOCK);

  const [onUpdateMany, setOnUpdateMany] = useState(false);
  const [updateManyPrice, setUpdateManyPrice] = useState(null);
  const [updateManyOriginPrice, setUpdateManyOriginPrice] = useState(null);
  const [updateManyAmount, setUpdateManyAmount] = useState(null);
  const [isUsingSalePage, setIsUsingSalePage] = useState(true);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageCountNumber, setPageCountNumber] = useState(1);

  const [isEdit, setIsEdit] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [editData, setEditData] = useState({});

  const [dataForDelete, setDataForDelete] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [amountStocks, setAmountStocks] = useState(0);


  const [optionData, setOptionData] = useState([]);
  const [optionDataEdit, setOptionDataEdit] = useState([]);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState();
  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);

  // default this month
  // let defaultStartMonth = moment().startOf("month").format("YYYY-MM-DD");
  // let defaultEndMonth = moment().endOf("month").format("YYYY-MM-DD");

  const [isDeleteProduct, setIsDeleteProduct] = useState(false);
  const [options, setOptions] = useState(false);
  // const [productId, setProductId] = useState();
  const [isUsing, setIsUsing] = useState("ALL");
  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: '',
    createdAt_lt: '',
  });
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [activeButton, setActiveButton] = useState("thisYear");
  const [orderBy, setOrderBy] = useState("createdAt_DESC");
 
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  useEffect(() => {
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  const _goProductAdd = () => {
    history.push(`/product-add`, { editMode: false, duplicateMode: false });
  };
  // const _goProductEdit = (pId) => {
  //   history.push(`/product-edit/${pId}`, {
  //     editMode: false,
  //     duplicateMode: false,
  //   });
  // };


  useEffect(() => {
    if (loadStocksDatas?.stocksV2) {
      setIsLoading(false);
      setStockDatas(loadStocksDatas?.stocksV2?.data ?? []);
      setStockTotal(loadStocksDatas?.stocksV2?.total ?? 0);
      setAmountStocks(loadStocksDatas?.stocksV2?.amountStocks ?? 0);
      setPageCountNumber(parseInt(loadStocksDatas?.stocksV2?.total / _limit) + 1);
    }
  }, [loadStocksDatas]);

  useEffect(() => {
    if (optionValueDatas?.optionValues?.data) {
      setOptionData(optionValueDatas?.optionValues?.data);
    }
  }, [optionValueDatas]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchText(debounceSearchText);
    }, 500);
    return () => clearTimeout(timer);
  }, [debounceSearchText])

  useEffect(() => {
    fetchProductStore();
  }, [pageNumber, _skip, isUsing, searchText, cdFillter, orderBy]);

  const editStockOption = async (_shopStock) => {
    let _newProductList = [];
    const _groupStockData = _.groupBy(_shopStock, "product.id");
    for (let [stockName, values] of Object.entries(_groupStockData)) {
      let totalAmount = 0;
      for (var i = 0; i < values.length; i++) {
        totalAmount += values[i]?.amount;
      }
      _newProductList.push({
        id: values[0]?.product.id,
        name: values[0].name,
        unit: values[0].unit,
        image: values[0].image,
        amount: totalAmount,
        shop: values[0]?.shop?.id,
        stock: values,
        createdAt: values[0]?.product?.createdAt,
        updatedAt: values[0]?.product?.updatedAt,
      });
    }
  };

  const handleUpload = async (event) => {
    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;
      await getPresignUrl({
        variables: {
          name: filename,
        },
      });
      setFileName(filename);
    } catch (error) {
      console.log(error);
    }
  };

  const onFileUpload = async (url) => {
    try {
      if (file && url) {
        await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
      }
    } catch (error) {
      console.log("ERROR: ", error);
    }
  };

  const fetchProductStore = async () => {
    try {
      setIsLoading(true);
      const SHOP_ID = localStorage.getItem("SHOP");
      let _where = {
        shop: SHOP_ID,
        isDeleted: false,
      };

      if (!_.isEmpty(cdFillter)) {
        let startDateComponents = splitDateTime(cdFillter?.createdAt_gte);
        let endDateComponents = splitDateTime(cdFillter?.createdAt_lt);
        _where = {
          ..._where,
          createdAt_gte: startDateComponents,
          createdAt_lt: endDateComponents,
        };
      }

      if (isUsing === "ISUSING")
        _where = {
          ..._where,
          isUsing: true,
        };

      if (isUsing === "NOUSED")
        _where = {
          ..._where,
          isUsing: false,
        };
      
      if (!_.isEmpty(searchText)) {
        _where = {
          ..._where,
          ...{ OR: [{ name: searchText }, { cfMessage: searchText }] },
        };
      }

      let variables = {
        where: _where,
        skip: (_skip - 1) * _limit,
        limit: _limit,
        orderBy: orderBy,
      };

      await getStocksDatas({ variables });

      if (!optionValueDatas) {
        await getOptionValues({
          variables: {
            where: {
              shop: SHOP_ID,
              isDeleted: false,
            },
          },
        });
      }
      
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("Error retrieving posts", error);
    }
  };

  const onNextPage = () => {
    setPageNumber(
      parseInt(pageNumber) != parseInt(pageCountNumber)
        ? parseInt(pageNumber) + 1
        : parseInt(pageCountNumber)
    );
  };

  const onBackPage = () => {
    setPageNumber(parseInt(pageNumber) != 1 ? parseInt(pageNumber) - 1 : 1);
  };

  const onChoosePage = (page) => {
    setPageNumber(parseInt(page));
  };

  const _updateListProduct = async (value) => {
    try {
      const SHOP_ID = localStorage.getItem("SHOP");
      setSearchText(value);
      if (!value) {
        await getStocksDatas({
          variables: {
            where: {
              isDeleted: false,
              shop: SHOP_ID,
            },
            skip: (_skip - 1) * _limit,
            limit: _limit,
            orderBy: "createdAt_DESC",
          },
        });
      } else {
        await getStocksDatas({
          variables: {
            where: {
              OR: [{ name: value }, { cfMessage: value }],
              isDeleted: false,
              shop: SHOP_ID,
            },
            skip: (_skip - 1) * _limit,
            limit: _limit,
            orderBy: "createdAt_DESC",
          },
        });
        // setPageNumber(1)
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const onDeleteProduct = async () => {
    try {
      const SHOP_ID = await localStorage.getItem("SHOP");
      setShowDeleteModal(false);
      setIsLoading(true);
      setOptions(false);
      if (deleteData) {
        await deleteStock({
          variables: {
            where: {
              id: deleteData.id,
            },
          },
        });
        fetchProductStore();

        addToast("ລຶບສິນຄ້າສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        setDeleteData();
        setIsLoading(false);
        setIsSelectAll(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const onEditData = async (data, index) => {
    const _stockOption = [];
    if (data?.optionValues.length > 0) {
      for (var i = 0; i < data?.optionValues.length; i++) {
        const _filterOption = optionData?.filter(
          (item) => item.name == data?.optionValues[i]?.name
        );
        _stockOption.push({
          name: data?.optionValues[i].name,
          defaultValue: data?.optionValues[i].value,
          values: _filterOption,
        });
      }
    }
    setOptionDataEdit(_stockOption);
    setIsEdit(true);
    setEditIndex(index);
    setEditData({
      ...data,
      amountAllOriginal: data?.amountAll ?? 0,
      amountAll: "",
    });
  };

  const onCancelEditData = async () => {
    setIsEdit(false);
    setEditIndex();
    setEditData({});
  };

  const onSaveEditData = async () => {
    try {
      const _stockOption = [];
      if (optionDataEdit.length > 0) {
        for (var i = 0; i < optionDataEdit.length; i++) {
          const _filterOption = optionDataEdit[i]?.values?.filter(
            (item) => item.value == optionDataEdit[i]?.defaultValue
          );
          _stockOption.push(_filterOption[0]?.id);
        }
      };

      const SHOP_ID = await localStorage.getItem("SHOP");
      if (!editData?.name) {
        addToast("ກະລຸນາປ້ອນຊື່ສິນຄ້າ!", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }

      // Removed unused amountAll computation; using editData.amountAll directly

      const data = {
        price: parseFloat(editData?.price.toString().replace(/,/g, "")),
        originPrice: parseFloat(
          editData?.originPrice.toString().replace(/,/g, "")
        ),
        amount: parseInt(editData?.amount ?? 0),
        amountAll: parseInt(editData?.amountAll ?? 0),
        amountSale: parseInt(editData?.amountSale ?? 0),
        name: editData?.name,
        cfMessage: editData?.cfMessage,
        sort: parseInt(editData?.sort),
        optionValues: _stockOption,
        image: fileName || editData?.image,
        isUsingSalePage: Boolean(editData?.isUsingSalePage),
      }

      setIsLoading(true);

      // Check Live On Air
      await updateStockForLiveOnAir();
      // Update Stock
      await updateStockV2({
        variables: {
          data,
          where: {
            id: editData?.id,
          },
        },
      });
      setFileName("");
      setFile();
      setIsEdit(false);
      setEditIndex();
      setEditData({});

      fetchProductStore();
      if (updateStockV2) {
        addToast("ແກ້ໄຂສຳເລັດແລ້ວ!", {
          appearance: "success",
          autoDismiss: true,
        });
      }


      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("error: ", error);
    }
  };

  

  const ImageThumb = ({ image }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          borderRadius: 5,
          height: 40,
          width: 40,
          cursor: "pointer",
        }}
      />
    );
  };

  const [enableButton, setEnableButton] = useState(true);

  const onSeletedAllProducts = async () => {
    if (isSelectAll) {
      setDataForDelete([]);
      setIsSelectAll(false);
    } else {
      let _dataForDelete = [];
      for (var i = 0; i < stockDatas.length; i++) {
        // if (!stockDatas[i]?.isUsing) {
        _dataForDelete.push(stockDatas[i].id);
        // }
      }
      setEnableButton(false);
      console.log("_dataForDelete====>", _dataForDelete);
      setDataForDelete(_dataForDelete);
      setIsSelectAll(true);
    }
    return;
  };

  const onSelectProduct = async (product) => {
    // console.log("productSelectThis6666---->", product?.id)
    setEnableButton(false);

    if (dataForDelete?.length > 0) {
      const _checkProduct = dataForDelete.filter((id) => id == product.id);
      if (_checkProduct?.length > 0) {
        const _checkProduct2 = dataForDelete.filter((id) => id != product.id);
        setDataForDelete(_checkProduct2);
      } else {
        const _dataForDelete = [...dataForDelete, product.id];
        setDataForDelete(_dataForDelete);
        // console.log("_dataForDelete====>", _dataForDelete);
      }
    } else {
      setDataForDelete([product.id]);
    }
  };

  const onDeleteProducts = async () => {
    try {
      const SHOP_ID = await localStorage.getItem("SHOP");
      setIsDeleteProduct(false);
      // console.log("dataForDelete55555", dataForDelete)
      setIsLoading(true);
      if (dataForDelete) {
        await updateManyStock({
          variables: {
            data: { isDeleted: true },
            where: {
              id_in: dataForDelete,
            },
          },
        }).then(() => {
          fetchProductStore();

          setDataForDelete([]);
          setIsLoading(false);
          setIsSelectAll(false);
          setEnableButton(true);
          addToast("ລຶບສິນຄ້າສໍາເລັດ", {
            appearance: "success",
            autoDismiss: true,
          });
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const _editManyStock = async () => {
    try {
      // console.log({ isUsingSalePage });
      const SHOP_ID = await localStorage.getItem("SHOP");
      setIsDeleteProduct(false);
      setIsLoading(true);
      if (dataForDelete && dataForDelete.length > 0) {
        let _data = {};
        if (updateManyPrice)
          _data = {
            ..._data,
            price: parseFloat(updateManyPrice.toString().replace(/,/g, "")),
            originPrice: parseFloat(
              updateManyOriginPrice.toString().replace(/,/g, "")
            ),
          };
        if (updateManyOriginPrice)
          _data = {
            ..._data,
            originPrice: parseFloat(
              updateManyOriginPrice.toString().replace(/,/g, "")
            ),
          };
        if (updateManyAmount)
          _data = {
            ..._data,
            amount: parseFloat(updateManyAmount.toString().replace(/,/g, "")),
          };

        _data = {
          ..._data,
          isUsingSalePage: isUsingSalePage,
        };
        // console.log({_data})
        await updateManyStock({
          variables: {
            data: _data,
            where: {
              id_in: dataForDelete,
            },
          },
        });
        // await getStocksDatas({
        //   variables: {
        //     where: {
        //       shop: SHOP_ID,
        //       isDeleted: false,
        //     },
        //     skip: (page - 1) * _limit,
        //     limit: _limit,
        //     orderBy: "createdAt_DESC",
        //   },
        // });
        // await getOptionValues({
        //   variables: {
        //     where: {
        //       shop: SHOP_ID,
        //       isDeleted: false,
        //     },
        //   },
        // });
        fetchProductStore();
        setDataForDelete([]);
        setIsLoading(false);
        setIsSelectAll(false);
        addToast("ແກ້ໄຂສິນຄ້າສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
      }
      setOnUpdateMany(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const onCloseUpdate = () => {
    setOnUpdateMany(false)
    setDataForDelete([])
    setIsSelectAll(false)
  }

  return (
    <div style={{ padding: 0 }}>
      <div> 
          <Card style={{ border: 'none', boxShadow: 'none', width: '100%' }}>
            <Card.Header>ລາຍງານສະຕ໋ອກສິນຄ້າໃນຮ້ານ</Card.Header>
            <Card.Body>
              <Card.Title>ລາຍການສິນຄ້າ: {stockTotal ?? 0 } </Card.Title>
              <Card.Title>ລວມຈຳນວນສິນຄ້າທັງໝົດ: {amountStocks ?? 0}</Card.Title>
              <Card.Text>
              ຈັດການສິນຄ້າ ລາຍລະອຽດສິນຄ້າ ແລະ ຄວບຄຸມສະຕ໊ອກຂອງສິນຄ້າລວມຂອງຮ້ານທັງຫມົດ
              </Card.Text>
              <div style={{ display: "flex", flexDirection: "row", gap:10 }}>
                <Button 
                  style={{
                    background: COLOR_APP,
                    color: "#fff",
                    borderRadius: 5,
                    width: "160px",
                  }}
                  onClick={_goProductAdd}>
                  <FontAwesomeIcon
                    icon={faPlus}
                    style={{
                      color: "#FFFFFF",
                      fontSize: "16px",
                      paddingRight: "5px",
                    }}
                  />{" "}
                  ເພີ່ມສິນຄ້າ
                </Button>
                <Button
                  onClick={() => history.push(`/product-exceal-add`)}
                  style={{
                    color: COLOR_TEXT,
                    background: "#f2f2f2",
                    border: `1px solid ${COLOR_TEXT}`
                  }}>
                  ເພີ່ມສິນຄ້າດ້ວຍ Excel
                </Button>
              </div>
            </Card.Body>
          </Card>
 
        {/* <div style={{ height: 20 }} /> */}
        {onUpdateMany && (
          <div style={{ padding: "0 1em" }}>
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label>ລາຄາຕົ້ນທືນ</Form.Label>
              <NumberFormat
                name="stockOriginPriceLak"
                className="form-control"
                onChange={(e) =>
                  setUpdateManyOriginPrice(
                    e?.target?.value < 0
                      ? -1 * e?.target?.value
                      : e?.target?.value ?? ""
                  )
                }
                value={updateManyOriginPrice ?? ""}
                placeholder="0"
                thousandSeparator={true}
                prefix={""}
              />
            </Form.Group>
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label>ລາຄາຂາຍ</Form.Label>
              <NumberFormat
                name="stockPriceLak"
                className="form-control"
                onChange={(e) =>
                  setUpdateManyPrice(
                    e?.target?.value < 0
                      ? -1 * e?.target?.value
                      : e?.target?.value ?? ""
                  )
                }
                value={updateManyPrice ?? ""}
                placeholder="0"
                thousandSeparator={true}
                prefix={""}
              />
            </Form.Group>
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label>ຈຳນວນ</Form.Label>
              <NumberFormat
                name="stockAmount"
                className="form-control"
                onChange={(e) =>
                  setUpdateManyAmount(
                    e?.target?.value < 0
                      ? -1 * e?.target?.value
                      : e?.target?.value ?? ""
                  )
                }
                value={updateManyAmount ?? ""}
                placeholder="0"
                thousandSeparator={true}
                prefix={""}
              />
            </Form.Group>
            <Form.Group controlId="exampleForm.ControlInput1">
              {/* <Form.Label>ເປີດຂາຍຢູ່ເຊວເພຈ</Form.Label> */}
              <div style={{ padding: "1.5em" }}>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label={isUsingSalePage ? "ເປີດຂາຍຢູ່ເຊວເພຈ" : "ປີດຂາຍຢູ່ເຊວເພຈ"}
                  name="isUsingSalePage"
                  onChange={(e) => setIsUsingSalePage(e?.target?.checked)}
                  checked={isUsingSalePage}
                />
              </div>
            </Form.Group>
            <Button
              onClick={onCloseUpdate}
              style={{
                border: "1px solid red",
                color: "red",
                width: 100,
                background: "#fff",
                marginTop: 10,
              }}>
              ຍົກເລີກ
            </Button>
            &nbsp;
            <Button
              onClick={() => _editManyStock()}
              style={{
                border: `1px solid ${COLOR_TEXT}`,
                color: COLOR_TEXT,
                width: 100,
                background: COLOR_GRAY,
                marginTop: 10,
              }}>
              ຢືນຢັນ
            </Button>
            <div style={{ height: 20 }} />
          </div>
        )}
        <div
          style={{
            borderRadius: 5,
            padding: 10,
            margin: 0,
          }}
          className="column">
          <div style={{ display: "flex",flexDirection:isMobile?"column":"row", gap:isMobile ? 10 : 2, justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: 10, flex: 1 }}>
              <input
                type="text"
                className="form-control"
                placeholder="ຄົ້ນຫາຊື່ສິນຄ້າ ຫຼື ລະຫັດສິນຄ້າ"
                onChange={(e) => setDebounceSearchText(e.target.value)} />
              <Form.Select
                value={orderBy}
                onChange={(e) => setOrderBy(e.target.value)}
                style={{ minWidth: "200px" }}
              >
                <option value="createdAt_DESC">ວັນທີ່ສ້າງ (ໃໝ່ສຸດ)</option>
                <option value="createdAt_ASC">ວັນທີ່ສ້າງ (ເກົ່າສຸດ)</option>
                <option value="updatedAt_DESC">ວັນທີ່ອັບເດດ (ໃໝ່ສຸດ)</option>
                <option value="updatedAt_ASC">ວັນທີ່ອັບເດດ (ເກົ່າສຸດ)</option>
                <option value="name_ASC">ຊື່ສິນຄ້າ (A-Z)</option>
                <option value="name_DESC">ຊື່ສິນຄ້າ (Z-A)</option>
                <option value="price_ASC">ລາຄາ (ຕ່ຳສຸດ)</option>
                <option value="price_DESC">ລາຄາ (ສູງສຸດ)</option>
                <option value="amount_ASC">ຈຳນວນ (ນ້ອຍສຸດ)</option>
                <option value="amount_DESC">ຈຳນວນ (ຫຼາຍສຸດ)</option>
                <option value="cfMessage_ASC">ຂໍ້ຄວາມ CF (A-Z)</option>
                <option value="cfMessage_DESC">ຂໍ້ຄວາມ CF (Z-A)</option>
              </Form.Select>
            </div>
            <div style={{ display: "flex", whiteSpace: "nowrap", gap: 10, marginLeft: 10 }}>
              <Button
                variant="outline-secondary"
                onClick={() => setIsCurrentModals(true)}
                style={{ width: "100%", display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}

              >
                <MdDateRange style={{ fontSize: 25 }} />
                {_.isEmpty(cdFillter) ? (
                  "mm/dd/yyyy"
                ) : (
                  <>
                    {convertCurrentDate(cdFillter?.createdAt_gte) + "-" + convertCurrentDate(cdFillter?.createdAt_lt)}
                  </>
                )}
              </Button>
              <button
                className="btn btn-app hoverme"
                style={{
                  float: "right",
                  background: "red",
                  color: "#fff",
                  borderRadius: 5,
                  margin: "0px 5px",
                }}
                // disabled={enableButton}
                disabled={dataForDelete.length <= 0}
                onClick={() => setIsDeleteProduct(true)}>
                <FontAwesomeIcon icon={faTrashAlt} />{" "}
                {width > 700 && "ລຶບສິນຄ້າ"}
              </button>
              {!onUpdateMany && (
                <button
                  className="btn btn-app hoverme"
                  style={{
                    float: "right",
                    border: `1px solid ${COLOR_TEXT}`,
                    background:
                      dataForDelete.length <= 0 ? "#f1f1f1" : "#fff",
                    color: COLOR_TEXT,
                    borderRadius: 5,
                  }}
                  disabled={dataForDelete.length <= 0}
                  onClick={() => setOnUpdateMany(true)}>
                  <FontAwesomeIcon icon={faEdit} />{" "}
                  {width > 700 && "ແກ້ໄຂສິນຄ້າ"}
                </button>
              )}
            </div>
          </div>
        </div>
        {(loadingStock && !loadStocksDatas) ? (
          <LoadingSpinner />
        ) : (
          <>
            {stockDatas.length > 0 ? (
              <Table responsive>
                <thead>
                  <tr style={{ alignItems: "center", whiteSpace: "nowrap" }}>
                    <th style={{ borderBottom: "none", alignItems: "center" }}>
                      <Form.Check
                        inline
                        id="ລຳດັບ"
                        label="ລຳດັບ"
                        type="checkbox"
                        checked={isSelectAll}
                        onClick={() => onSeletedAllProducts()}
                      />
                    </th>
                    <th style={{ borderBottom: "none" }}>ຮູບສິນຄ້າ</th>
                    <th style={{ borderBottom: "none" }}>ຊື່ສິນຄ້າ (ລະຫັດ CF)</th>
                    <th style={{ borderBottom: "none" }}>ຈຳນວນທີ່ນຳເຂົ້າ</th>
                    <th style={{ borderBottom: "none" }}>ຈຳນວນທີ່ຍັງເຫຼືອ</th>
                    <th style={{ borderBottom: "none" }}>ຈຳນວນທີ່ຂາຍໄປ</th>
                    <th style={{ borderBottom: "none" }}>{isEdit ? "sort" : "ປະເພດ"}</th>
                    <th style={{ borderBottom: "none" }}>ລາຄາຂາຍ</th>
                    <th style={{ borderBottom: "none" }}>ລາຄາຕົ້ນທືນ</th>
                    <th style={{ borderBottom: "none" }}>ວັນທີ່ສ້າງສິນຄ້າ</th>
                    <th style={{ borderBottom: "none" }}>ໃຊ້ເຊວເພຈ</th>
                    <th style={{ borderBottom: "none" }}>ຈັດການ</th>
                  </tr>
                </thead>
                {loadingStock && !loadStocksDatas ? (
                  <tbody>
                    <tr>
                      <td colSpan={10}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}>
                          <LoadingSpinner />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {stockDatas &&
                      stockDatas?.map((product, index) => (
                        <tr
                          key={index}
                          style={{ alignItems: "center", whiteSpace: "nowrap" }}>
                          <td
                            style={{
                              borderBottom: "none",
                              display: "flex",
                              alignSelf: "center",
                              alignItems: "center",
                            }}>
                            {isSelectAll ? (
                              <Form.Check
                                inline
                                type="checkbox"
                                label={index + 1 + _limit * (_skip - 1)}
                                checked={true}
                                disabled
                              />
                            ) : dataForDelete.length <= 0 ? (
                              <Form.Check
                                inline
                                type="checkbox"
                                label={index + 1 + _limit * (_skip - 1)}
                                checked={false}
                                onClick={() => onSelectProduct(product)}
                              />
                            ) : (
                              <Form.Check
                                inline
                                type="checkbox"
                                label={index + 1 + _limit * (_skip - 1)}
                                onClick={() => onSelectProduct(product)}
                              />
                            )}
                          </td>
                          <td>
                            {isEdit == true && editIndex === index ? (
                              <div>
                                <input
                                  type="file"
                                  id="file-upload"
                                  onChange={handleUpload}
                                  hidden
                                />
                                <label htmlFor="file-upload">
                                  {file ? (
                                    <ImageThumb image={file} />
                                  ) : (
                                    <img
                                      src={imageRender(editData?.image ?? "")}
                                      style={{
                                        borderRadius: "10%",
                                        cursor: "pointer",
                                        height: 60,
                                        width: 60,
                                      }}
                                    />
                                  )}
                                </label>
                              </div>
                            ) : (
                              <img
                                src={imageRender(product?.image)}
                                style={{
                                  borderRadius: "10%",
                                  height: 60,
                                  width: 60,
                                }}
                              />
                            )}
                          </td>
                          <td>
                            {isEdit == true && editIndex === index ? (
                              <div>
                                <Form.Control
                                  type="text"
                                  name="title"
                                  onChange={(e) => {
                                    let _data = editData;
                                    _data = {
                                      ...editData,
                                      name: e?.target?.value,
                                    };
                                    setEditData(_data);
                                  }}
                                  value={editData.name}
                                  placeholder="ຊື່ສິນຄ້າ..."
                                  style={{
                                    border: editData.name ? "" : "solid 1px red",
                                  }}
                                />

                                <br />

                                <Form.Control
                                  type="text"
                                  name="cfMessage"
                                  onChange={(e) => {
                                    let _data = editData;
                                    _data = {
                                      ...editData,
                                      cfMessage: e?.target?.value,
                                    };
                                    setEditData(_data);
                                  }}
                                  value={editData.cfMessage}
                                  placeholder="ຊື່ສິນຄ້າ..."
                                  style={{
                                    border: editData.cfMessage
                                      ? ""
                                      : "solid 1px red",
                                  }}
                                />

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}>
                                  {optionDataEdit?.length > 0 &&
                                    optionDataEdit.map((item, index) => (
                                      <Form.Control
                                        key={index}
                                        as="select"
                                        name="selectStatus"
                                        custom
                                        value={item?.defaultValue}
                                        onChange={(e) => {
                                          let _optionDataEdit = [
                                            ...optionDataEdit,
                                          ];
                                          _optionDataEdit[index].defaultValue =
                                            e?.target?.value;
                                          setOptionDataEdit(_optionDataEdit);
                                        }}>
                                        {item?.values.length > 0 &&
                                          item?.values.map((item2, i) => (
                                            <option key={i} value={item2?.value}>
                                              {item2?.value}
                                            </option>
                                          ))}
                                      </Form.Control>
                                    ))}
                                </div>
                              </div>
                            ) : (
                              <div style={{ maxWidth: 300, overflow: 'hidden' }}>
                                {product?.name || "ຍັງບໍ່ກໍານົດ"}
                                {product?.optionValues.length > 0 &&
                                  product?.optionValues?.map(
                                    (optionvalue, optionvalueIndex) => (
                                      <span key={optionvalueIndex}>
                                        {" \t "} {optionvalue?.value}{" "}
                                      </span>
                                    )
                                  )}{" "}
                                <span
                                  style={{
                                    color: COLOR_APP,
                                    fontWeight: "bold",
                                  }}>
                                  ({product?.cfMessage ?? "ຍັງບໍ່ກໍານົດ"})
                                </span>
                              </div>
                            )}
                          </td>
                          <td>
                            {isEdit === true && editIndex === index ? (
                              <div>
                                <Form.Control
                                  type="text"
                                  value={product?.amountAll ?? 0}
                                  disabled
                                />
                                <br />
                                <Form.Control
                                  type="text"
                                  name="amountAll"
                                  value={editData?.amountAll ?? ""}
                                  onChange={(e) => {
                                    const v = e?.target?.value;
                                    const next = v === "" ? 0 : parseInt(v, 10);
                                    const _data = {
                                      ...editData,
                                      amountAll: Number.isNaN(next) ? 0 : next,
                                    };
                                    setEditData(_data);
                                  }}
                                  placeholder="ຈຳນວນທີ່ນຳເຂົ້າ..."
                                  style={{
                                    width: '100%',}}
                                />
                              </div>
                            ) : (
                              <div>
                                {product?.amountAll ?? 0} {product?.unit ?? ""}
                              </div>
                            )}
                          </td>
                          <td>
                            {isEdit == true && editIndex === index ? (
                              <div>
                                {/* Amount (first input, editable, writes final amount) */}
                                <Form.Control
                                  type="text"
                                  name="amount"
                                  value={editData?.amount}
                                  onChange={(e) => {
                                    const v = e?.target?.value;
                                    if (v === "") {
                                      setEditData({
                                        ...editData,
                                        amount: "",
                                        amountDelta: undefined,
                                        amountDeltaText: undefined,
                                      });
                                      return;
                                    }

                                    const n = parseInt(v, 10);
                                    if (Number.isNaN(n) || n < 0) {
                                      // ignore invalid or negative
                                      return;
                                    }
                                    setEditData({
                                      ...editData,
                                      amount: n,
                                      amountDelta: undefined,
                                      amountDeltaText: undefined,
                                    });
                                  }}
                                  placeholder="ສິນຄ້າຍັງເຫຼືອ..."
                                  style={{
                                    width: '100%',
                                    border:
                                      editData?.amount === ""
                                        ? "solid 1px red"
                                        : "",
                                  }}
                                />
                                <br />
                                {/* Amount delta (second input, allow negative) */}
                                <Form.Control
                                  type="text"
                                  name="amountDelta"
                                  value={
                                    editData?.amountDeltaText !== undefined
                                      ? editData.amountDeltaText
                                      : (typeof editData?.amountDelta === 'number'
                                          ? String(editData?.amountDelta)
                                          : "")
                                  }
                                  onChange={(e) => {
                                    const v = e?.target?.value;
                                    // allow typing empty or single '-'
                                    if (v === "" || v === "-") {
                                      const base = product?.amount ?? 0;
                                      setEditData({
                                        ...editData,
                                        amountDeltaText: "0",
                                        amountDelta: 0,
                                        amount: base,
                                      });
                                      return;
                                    }

                                    const n = parseInt(v, 10);
                                    if (Number.isNaN(n)) {
                                      return;
                                    }

                                    const base = product?.amount ?? 0;
                                    // treat any input as removal amount: always negative
                                    const remove = -Math.abs(n);
                                    const clampedDelta = Math.max(-base, remove); // do not reduce below zero stock
                                    const finalAmount = Math.max(0, base + clampedDelta);
                                    setEditData({
                                      ...editData,
                                      amountDeltaText: String(clampedDelta),
                                      amountDelta: clampedDelta,
                                      amount: finalAmount,
                                    });
                                  }}
                                  onFocus={(e) => {
                                    if (
                                      (editData?.amountDeltaText === undefined || editData?.amountDeltaText === "") &&
                                      typeof editData?.amountDelta !== 'number'
                                    ) {
                                      const base = product?.amount ?? 0;
                                      setEditData({
                                        ...editData,
                                        amountDeltaText: "0",
                                        amountDelta: 0,
                                        amount: base,
                                      });
                                    }
                                  }}
                                  placeholder="ລົບຈຳນວນ..."
                                  style={{
                                    width: '100%',
                                    border:
                                      editData?.amountDeltaText === "" ||
                                      editData?.amountDeltaText === "-"
                                        ? "solid 1px red"
                                        : "",
                                  }}
                                />
                              </div>
                            ) : (
                              <div>
                                {product?.amount ?? 0} {product?.unit ?? ""}
                              </div>
                            )}
                          </td>
                          <td>
                            {isEdit == true && editIndex === index ? (
                              <Form.Control
                                type="text"
                                name="amountSale"
                                disabled={true}
                                onChange={(e) => {
                                  let _data = editData;
                                  _data = {
                                    ...editData,
                                    amountSale: parseInt(e?.target?.value),
                                  };
                                  setEditData(_data);
                                }}
                                value={editData.amountSale || 0}
                                defaultValue={editData.amountSale || 0}
                                placeholder="ຈຳນວນສິນຄ້າທີ່ຂາຍໄປ..."
                                style={{
                                  border: editData.amountSale ? "" : "solid 1px red",
                                }}
                              />
                            ) : (
                              <div>
                                {product?.amountSale ?? 0} {product?.unit ?? ""}
                              </div>
                            )}
                          </td>
                          <td>
                            {isEdit == true && editIndex === index ? (
                              <Form.Control
                                type="number"
                                name="sort"
                                value={editData?.sort ?? ""}
                                onChange={(e) => {
                                  let _data = editData;
                                  if (e?.target?.value) {
                                    _data = {
                                      ...editData,
                                      sort:
                                        e?.target?.value < 0
                                          ? -1 * e?.target?.value
                                          : e?.target?.value,
                                    };
                                  } else {
                                    _data = {
                                      ...editData,
                                      sort: null,
                                    };
                                  }
                                  setEditData(_data);
                                }}
                                placeholder="0"
                              />
                            ) : (
                              <div>{product?.categoryName ?? "-"}</div>
                            )}
                          </td>
                          <td>
                            {isEdit == true && editIndex === index ? (
                              <NumberFormat
                                // type="number"
                                name="price"
                                className="form-control"
                                onChange={(e) => {
                                  let _data = editData;
                                  if (e?.target?.value) {
                                    _data = {
                                      ...editData,
                                      price:
                                        e?.target?.value < 0
                                          ? -1 * e?.target?.value
                                          : e?.target?.value,
                                    };
                                  } else {
                                    _data = {
                                      ...editData,
                                      price: null,
                                    };
                                  }
                                  setEditData(_data);
                                }}
                                value={editData?.price ?? ""}
                                placeholder="0"
                                thousandSeparator={true}
                                prefix={""}
                              />
                            ) : (
                              <div>
                                {moneyCurrency(product?.price ?? 0)}{" "}
                                {product?.currency ?? ""}
                              </div>
                            )}
                          </td>
                          <td>
                            {isEdit == true && editIndex === index ? (
                              <NumberFormat
                                // type="number"
                                name="originPrice"
                                className="form-control"
                                onChange={(e) => {
                                  let _data = editData;
                                  if (e?.target?.value) {
                                    _data = {
                                      ...editData,
                                      originPrice:
                                        e?.target?.value < 0
                                          ? -1 * e?.target?.value
                                          : e?.target?.value,
                                    };
                                  } else {
                                    _data = {
                                      ...editData,
                                      originPrice: null,
                                    };
                                  }
                                  setEditData(_data);
                                }}
                                value={editData?.originPrice ?? ""}
                                placeholder="0"
                                thousandSeparator={true}
                                prefix={""}
                              />
                            ) : (
                              <div>
                                {moneyCurrency(product?.originPrice ?? 0)}{" "}
                                {product?.currency ?? ""}
                              </div>
                            )}
                          </td>
                          <td>
                            {moment(product?.createdAt).format(
                              "DD/MM/YYYY HH:mm A"
                            )}
                          </td>

                          <td>
                            {isEdit === true && editIndex === index ? (
                              <Form.Select
                                style={{ fontSize: "16px", padding: 2 }}
                                value={editData?.isUsingSalePage ? "OPEN" : "CLOSE"}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    isUsingSalePage: e.target.value === "OPEN",
                                  })
                                }
                              >
                                <option value="OPEN">ເປີດ</option>
                                <option value="CLOSE">ປີດ</option>
                              </Form.Select>
                            ) : product?.isUsingSalePage === false ? (
                              <p style={{ color: "red" }}>ປີດ</p>
                            ) : (
                              <p style={{ color: "green" }}>ເປີດ</p>
                            )}
                          </td>
                          {isEdit == true && editIndex === index ? (
                            <td
                              className="row"
                              style={{ margin: 0, whiteSpace: "nowrap" }}>
                              <button
                                className="btn hoverme col-6 align-self-start"
                                onClick={() => onSaveEditData()}
                                style={{
                                  background: COLOR_APP,
                                  color: COLOR_TEXT,
                                }}>
                                <FontAwesomeIcon
                                  icon={faSave}
                                  style={{
                                    background: COLOR_APP,
                                    color: COLOR_WHITE,
                                  }}
                                />{" "}
                              </button>
                              <br/>
                              &nbsp;
                              <button
                                className="btn hoverme col-6"
                                style={{
                                  borderColor: COLOR_TEXT,
                                  color: "red",
                                }}
                                onClick={() => onCancelEditData()}>
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  style={{ color: "grey" }}
                                />
                                {" \t"}
                              </button>
                            </td>
                          ) : (
                            <td style={{ margin: 0, whiteSpace: "nowrap" }}>
                              <button
                                className="btn hoverme"
                                onClick={() => onEditData(product, index)}>
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  style={{ color: COLOR_TEXT }}
                                />
                              </button>
                              <button
                                className="btn hoverme"
                                onClick={() => {
                                  setDeleteData(product);
                                  setShowDeleteModal(true);
                                }}>
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  style={{ color: "red" }}
                                />
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                  </tbody>
                )}
              </Table>
            ) : (
              <div>
                <Table responsive>
                  <thead>
                    <tr style={{ alignItems: "center", whiteSpace: "nowrap" }}>
                      <th
                        style={{
                          borderBottom: "1px solid #eee",
                          alignItems: "center",
                        }}>
                        <Form.Check
                          inline
                          label="ລຳດັບ"
                          type="checkbox"
                          checked={isSelectAll}
                          onClick={() => onSeletedAllProducts()}
                        />
                      </th>
                      <th style={{ borderBottom: "1px solid #eee" }}>ຮູບ</th>
                      <th style={{ borderBottom: "1px solid #eee" }}>
                        ຊື່ສິນຄ້າ (ລະຫັດ CF)
                      </th>
                      <th style={{ borderBottom: "1px solid #eee" }}>ຈຳນວນ</th>
                      <th style={{ borderBottom: "1px solid #eee" }}>ລາຄາຂາຍ</th>
                      <th style={{ borderBottom: "1px solid #eee" }}>
                        ລາຄາຕົ້ນທືນ
                      </th>
                      <th style={{ borderBottom: "1px solid #eee" }}>
                        ວັນທີ່ສ້າງສິນຄ້າ
                      </th>
                      <th style={{ borderBottom: "1px solid #eee" }}>
                        {" "}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <p style={{ padding: 0, margin: 0 }}>ສະຖານະ</p>
                          <Form.Select
                            defaultValue={isUsing}
                            style={{
                              fontSize: "16px",
                              padding: 2,
                            }}
                            aria-label="Default select example"
                            onChange={(e) => setIsUsing(e.target.value)}>
                            <option value="ALL">ທັງຫມົດ</option>
                            <option value="ISUSING">ຖືກໃຊ້ງານ</option>
                            <option value="NOUSED">ຍັງບໍ່ໃຊ້ງານ</option>
                          </Form.Select>
                        </div>
                      </th>
                      <th style={{ borderBottom: "1px solid #eee" }}>ຈັດການ</th>
                    </tr>
                  </thead>
                </Table>
                {loadStocksDatas?.stocks?.length <= 0 && (
                  <EmptyComponent
                    title={"ບໍ່ມີສິນຄ້າ"}
                    subTitle={
                      "ຈັດການສິນຄ້າ ລາຍລະອຽດສິນຄ້າ ແລະ ຄວບຄຸມສະຕ໊ອກຂອງສິນຄ້າລວມຂອງຮ້ານທັງຫມົດ"
                    }

                  />
                )}
              </div>
            )}


          </>
        )}


        {/* <PaginationsV1
          count={stockTotal}
          rowsPerPage={_limit}
          page={page}
          pageAll={pageAll}
          onPageChange={handleChangePage}
          /> */}

        {Pagination_helper(stockTotal, "/products", ``)}
      </div>

      <ModalConfirmComponent
        showConfirmModal={showDeleteModal ? showDeleteModal : isDeleteProduct}
        handleCancel={() => {
          showDeleteModal
            ? setShowDeleteModal(false)
            : setIsDeleteProduct(false);
        }}
        handleConfirm={showDeleteModal ? onDeleteProduct : onDeleteProducts}
        title="ແຈ້ງເຕືອນ"
        text={
          showDeleteModal
            ? "ທ່ານຕ້ອງການທີ່ຈະລຶບສິນຄ້ານີ້ແທ້ບໍ່?"
            : "ທ່ານຕ້ອງການທີ່ຈະລຶບສິນຄ້າທັງໝົດນີ້ແທ້ບໍ່?"
        }
      />

      <CurrentDateModal
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setCdFillter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
        backdrop={true}

      />
    </div>
  );
}

export default Products;
